import React from 'react';
import PropTypes from 'prop-types';
import Week from 'components/Filters/Week';
import ViewSelector from 'components/ViewSelector/ViewSelector';


const WeekFilter = ({ selectedWeek, onClick, weeks, selectedView, selectView, brand, brandClass }) => (
  <div className="react-week-filter-container-con">
    <div className="react-week-filter-container">
      <div className="react-week-filter-title">Műsorhét</div>
      {
        weeks && weeks.map(week => (
          <Week
            key={week}
            title={week.toString().slice(4)}
            selectedWeek={selectedWeek}
            week={week}
            onClick={() => { onClick(week); }}
            brandClass={brandClass}
          />
        ))
      }
    </div>
    {brand !== 0 ? <ViewSelector selectView={(view) => { selectView(view); }} selectedView={selectedView} brandClass={brandClass} /> : null}
  </div>

);

WeekFilter.propTypes = {
  selectedWeek: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  weeks: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  onClick: PropTypes.func.isRequired,
  brandClass: PropTypes.string,
  selectView: PropTypes.func.isRequired,
  selectedView: PropTypes.string.isRequired,
  brand: PropTypes.number,
};

WeekFilter.defaultProps = {
  weeks: null,
  brand: null,
  brandClass: 'react-artmozi',
  selectedWeek: null,
};

export default WeekFilter;
